class StickyProVariantSelect extends HTMLElement {
  constructor() {
    super();

    this.select = this.querySelector("#sticky__variant");

    if (!this.select) return;

    this.select.addEventListener("change", () => {
      this.updateStickyVariant();
    });
  }

  connectedCallback() {
    if (!this.select) {
      this.select = this.querySelector("#sticky__variant");
    }

    if (this.select) {
      this.updateStickyVariant();
    }
  }

  updateStickyVariant() {
    const select = this.select;
    const selectedOption = select.options[select.selectedIndex];

    if (!selectedOption) return;

    const sectionId = this.dataset.section;

    /* -------------------------------
       UPDATE VARIANT ID
    -------------------------------- */

    const productForm = document.querySelector(
      `#product-sticky-form-${sectionId}`
    );

    if (productForm) {
      const variantInput = productForm.querySelector('input[name="id"]');

      if (variantInput) {
        variantInput.value = selectedOption.value;

        variantInput.dispatchEvent(
          new Event("change", {
            bubbles: true
          })
        );
      }
    }


    /* -------------------------------
       STICKY WRAPPER
    -------------------------------- */

    const stickyWrapper = this.closest(".product__sticky");

    if (!stickyWrapper) return;


    /* -------------------------------
       UPDATE PRICE
    -------------------------------- */

    const priceElement =
      stickyWrapper.querySelector(".sticky__price");

    if (priceElement && selectedOption.dataset.price) {
      priceElement.textContent =
        selectedOption.dataset.price;
    }


    /* -------------------------------
       COMPARE AT PRICE + DISCOUNT
    -------------------------------- */

    const comparePriceElement =
      stickyWrapper.querySelector(".sticky__compare_price");

    const discountElement =
      stickyWrapper.querySelector(".sticky__discount");

    const priceRaw =
      parseInt(selectedOption.dataset.priceRaw || "0", 10);

    const comparePriceRaw =
      parseInt(
        selectedOption.dataset.comparePriceRaw || "0",
        10
      );

    if (
      comparePriceRaw > 0 &&
      comparePriceRaw > priceRaw
    ) {

      if (comparePriceElement) {
        comparePriceElement.textContent =
          selectedOption.dataset.comparePrice;

        comparePriceElement.hidden = false;
      }

      const discount = Math.round(
        ((comparePriceRaw - priceRaw) * 100) /
          comparePriceRaw
      );

      if (discountElement) {
        discountElement.textContent =
          discount + "% OFF";

        discountElement.hidden = false;
      }

    } else {

      if (comparePriceElement) {
        comparePriceElement.hidden = true;
      }

      if (discountElement) {
        discountElement.hidden = true;
      }
    }


    /* -------------------------------
       UPDATE PRODUCT IMAGE
    -------------------------------- */

    const productImage =
      stickyWrapper.querySelector(
        ".sticky_pro_img img"
      );

    const newImage =
      selectedOption.dataset.image;

    if (productImage && newImage) {
      productImage.src = newImage;
      productImage.removeAttribute("srcset");
    }


    /* -------------------------------
       ADD TO CART / SOLD OUT
    -------------------------------- */

    const addButton =
      stickyWrapper.querySelector(
        '.sticky__form_button button[name="add"]'
      );

    if (addButton) {

      const isAvailable =
        selectedOption.dataset.available === "true";

      const addText =
        addButton.dataset.addText || "Add to cart";

      const soldOutText =
        addButton.dataset.soldOutText || "Sold out";

      if (isAvailable) {

        addButton.disabled = false;
        addButton.textContent = addText;

      } else {

        addButton.disabled = true;
        addButton.textContent = soldOutText;

      }
    }
  }
}


/* Prevent duplicate custom element error
   inside Shopify theme editor */
if (
  !customElements.get("sticky-variant-select")
) {
  customElements.define(
    "sticky-variant-select",
    StickyProVariantSelect
  );
}


/* =====================================
   STICKY CART SHOW / HIDE
===================================== */

document.addEventListener(
  "DOMContentLoaded",
  function () {

    const buyButtonForm =
      document.querySelector(
        ".product_buy_button_form"
      );

    const productStickyWrapper =
      document.querySelector(
        ".product__sticky"
      );

    if (
      !buyButtonForm ||
      !productStickyWrapper
    ) {
      return;
    }


    function getBuyButtonPosition() {
      const rect =
        buyButtonForm.getBoundingClientRect();

      return (
        rect.top +
        window.scrollY +
        rect.height
      );
    }


    let stickyTriggerPosition =
      getBuyButtonPosition();


    function updateStickyCart() {

      if (
        window.scrollY >
        stickyTriggerPosition
      ) {

        productStickyWrapper.classList.add(
          "sticky"
        );

        document.body.classList.add(
          "sticky__cart"
        );

      } else {

        productStickyWrapper.classList.remove(
          "sticky"
        );

        document.body.classList.remove(
          "sticky__cart"
        );

      }
    }


    window.addEventListener(
      "scroll",
      updateStickyCart,
      { passive: true }
    );


    window.addEventListener(
      "resize",
      function () {
        stickyTriggerPosition =
          getBuyButtonPosition();

        updateStickyCart();
      }
    );


    updateStickyCart();
  }
);